import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import './ImageCompressor.css'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const formatSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`
}

const ImageCompressor = () => {
  useDocumentMeta({
    title: 'Compressor de Imagem Online Grátis  jarder.dev',
    description:
      'Comprima fotos JPG/PNG direto no navegador, sem enviar pra ' +
      'nenhum servidor. Ajuste a qualidade e baixe o resultado.',
  })

  const [original, setOriginal] = useState(null)
  const [quality, setQuality] = useState('0.7')
  const [compressed, setCompressed] = useState(null)
  const canvasRef = useRef(null)
  const imageRef = useRef(null)

  const handleFile = (event) => {
    const file = event.target.files[0]
    if (!file) return
    const url = URL.createObjectURL(file)
    const img = new Image()
    img.onload = () => {
      imageRef.current = img
      setOriginal({ url, size: file.size, width: img.width, height: img.height })
      setCompressed(null)
    }
    img.src = url
  }

  const compress = () => {
    const img = imageRef.current
    const canvas = canvasRef.current
    if (!img || !canvas) return

    canvas.width = img.width
    canvas.height = img.height
    const ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0)

    canvas.toBlob(
      (blob) => {
        setCompressed({ url: URL.createObjectURL(blob), size: blob.size })
        trackEvent('tool_generate', { tool: 'image_compressor' })
      },
      'image/jpeg',
      Number(quality),
    )
  }

  const download = () => {
    if (!compressed) return
    const link = document.createElement('a')
    link.href = compressed.url
    link.download = 'imagem-comprimida.jpg'
    link.click()
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Compressor de Imagem</h1>
      <p className="tool-disclaimer">
        Tudo processado no seu navegador  a imagem nunca sai do seu
        computador.
      </p>

      <div className="tool-field">
        <label htmlFor="image-input">Escolha uma imagem (JPG ou PNG)</label>
        <input
          id="image-input"
          type="file"
          accept="image/jpeg,image/png"
          onChange={handleFile}
        />
      </div>

      {original && (
        <>
          <div className="tool-field">
            <label htmlFor="quality">
              Qualidade: {Math.round(Number(quality) * 100)}%
            </label>
            <input
              id="quality"
              type="range"
              min="0.1"
              max="1"
              step="0.05"
              value={quality}
              onChange={(e) => setQuality(e.target.value)}
            />
          </div>

          <button type="button" className="tool-button" onClick={compress}>
            Comprimir
          </button>

          <div className="image-compare">
            <div className="image-compare-item">
              <span className="tool-result-label">
                Original  {formatSize(original.size)}
              </span>
              <img src={original.url} alt="Original" />
            </div>
            {compressed && (
              <div className="image-compare-item">
                <span className="tool-result-label">
                  Comprimida  {formatSize(compressed.size)}
                </span>
                <img src={compressed.url} alt="Comprimida" />
                <button
                  type="button"
                  className="tool-button tool-button-secondary"
                  onClick={download}
                >
                  Baixar
                </button>
              </div>
            )}
          </div>
        </>
      )}

      <canvas ref={canvasRef} style={{ display: 'none' }} />

      <div className="tool-info-section">
        <h2>Como funciona a compressão</h2>
        <p>
          A imagem é redesenhada num canvas e reexportada como JPEG com o
          nível de qualidade escolhido  quanto menor a qualidade, mais o
          algoritmo descarta detalhes que o olho humano pouco percebe,
          reduzindo o tamanho do arquivo. É uma boa forma de deixar fotos
          mais leves para enviar por WhatsApp, e-mail ou publicar num
          site sem pesar o carregamento da página.
        </p>
      </div>
    </div>
  )
}

export default ImageCompressor
